module.exports = __webpack_public_path__ + "img/GH-corporate-002sp.a63fad70.png";